// extracted by mini-css-extract-plugin
export default {"login-form":"LoginForm_login-form__UpAlw","login-form__logo-wrapper":"LoginForm_login-form__logo-wrapper__qKzmG","login-form__error":"LoginForm_login-form__error__q2K90"};